import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Download from '../components/Download'

Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/index.html',
            name: 'Index',
            component: Index
        },
        {
            path: '/DownloadApp.html',
            name: 'Download',
            component: Download
        },

    ]
})
